import React from 'react'

export default function Label({
    text,
    className,
    size = 'small',
}: {
    text: string
    className?: string
    size?: 'small' | 'medium' | 'large'
}): JSX.Element {
    const sizeClasses = size === 'large' ? 'text-base px-2' : size === 'medium' ? 'text-sm px-1' : 'text-xs px-1'
    return (
        <span
            className={`!dark:text-white !dark:bg-blue/50 m-[-2px]
                inline-block rounded-sm !bg-blue/10 px-1
                py-0.5 font-medium text-primary/75 !text-blue dark:bg-gray-accent-dark dark:text-primary-dark/60 ${sizeClasses} ${className}`}
        >
            {text}
        </span>
    )
}
